// removed by extract-text-webpack-plugin
module.exports = {"modal":"modal__2EkLN"};


//////////////////
// WEBPACK FOOTER
// ./components/modal/style.scss
// module id = tv8R
// module chunks = 17